export interface SettingsGroupsRouter {
  goToAddRole(companyId: string): void;
  goToList(query?: string): void;
}

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const SettingsGroupsRouter = Symbol('SettingsGroupsRouter');
